// src/pages/FullAbout.jsx
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom"; // Import useLocation
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/Footer";
import "./FullAbout.css"; // We will create this CSS file next
import AboutHero from "./AboutHero/AboutHero";
import AboutJourney from "./AboutJourney/AboutJourney";

import OurApproach from "./OurApproach/OurApproach";
import OurStrengths from "./OurStrengths/OurStrengths";
import ClientsSection from '../../pages/ClientsSection';

const FullAbout = () => {
  const location = useLocation();

  // Scroll logic
  useEffect(() => {
    if (location.state && location.state.scrollTo) {
      const sectionId = location.state.scrollTo;
      const element = document.getElementById(sectionId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="full-about-page fade-in">
      <Navbar />
      <AboutHero />
      <AboutJourney />
      <OurApproach />
      <OurStrengths />
      <ClientsSection />
      <Footer />
    </div>
  );
};

export default FullAbout;
